import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { lightTheme, darkTheme } from 'src/styles/Theme'

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: ${(props) => (props.isScrollable ? 'initial' : 'hidden')};
    font-size: ${(props) => props.theme.font.size.medium};
  }

  .theme-transition {
    ${({ theme }) => theme.transition};
  }

  ${(props) =>
    Object.keys(props.theme.color).map(
      (key) =>
        `.bg-${key} { background-color: ${props.theme.color[key]}; }
        .text-${key} { color: ${props.theme.color[key]} !important; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.family).map(
      (key) =>
        `.font-family-${key} { font-family: ${props.theme.font.family[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.size).map(
      (key) => `.font-size-${key} { font-size: ${props.theme.font.size[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.weight).map(
      (key) =>
        `.font-weight-${key} { font-weight: ${props.theme.font.weight[key]}; }`
    )}

  a {
    color: inherit;

    &:hover {
      color: inherit;
    }
  }

  /* UBO cookie consent (renders in a shadow DOM, styled via variables and parts) */
  :root {
    --ubo-consent-color-bg: #ffffff;
    --ubo-consent-color-text: #1d3660;
    --ubo-consent-color-primary: #070744;
    --ubo-consent-color-primary-text: #ffffff;
    --ubo-consent-color-link: #0507ec;
    --ubc-font: ${({ theme }) => theme.font.family.primary};
    --ubc-title-font: ${({ theme }) => theme.font.family.headings};
    --ubc-title-size: 22px;
    --ubc-font-size: 15px;
    --ubc-muted: #4a5d80;
    --ubc-border: #e5e5e5;
    --ubc-surface: #f5f5f7;
    --ubc-switch-off: #c9cfdb;
    --ubc-secondary-border: #1d3660;
    --ubc-fab-bg: #0507ec;
    --ubc-overlay: rgba(5, 26, 64, 0.7);
    --ubc-shadow: 0 20px 60px rgba(5, 26, 64, 0.25);
    --ubc-radius: 25px;
    --ubc-btn-radius: 25px;
  }

  #ubo-consent::part(dialog) {
    border: none;
  }

  #ubo-consent::part(title) {
    font-weight: 700;
  }

  #ubo-consent::part(button) {
    font-weight: 700;
    transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  }

  #ubo-consent::part(button-primary):hover {
    filter: none;
    background-color: #0507ec;
    border-color: #0507ec;
  }

  #ubo-consent::part(button-secondary):hover {
    background-color: #1d3660;
    border-color: #1d3660;
    color: #ffffff;
  }
`

const Theme = ({ children, darkMode = true, isScrollable = true }) => (
  <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
    <GlobalStyle isScrollable={isScrollable} />
    {children}
  </ThemeProvider>
)

export default Theme
